/* eslint-disable */
// TODO: conver to functional component
import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';

import Component from "components/component";

export default class TextOption extends Component {
  static propTypes = {
    optionValue: ImmutablePropTypes.map,
    isSelected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    selectable: PropTypes.bool.isRequired,
    inSlider: PropTypes.bool,
    displayUpchargeAmount: PropTypes.string,
    showOptionPrice: PropTypes.bool.isRequired
  };

  static defaultProps = {
    showOptionPrice: false
  };

  render() {
    const {
      optionValue,
      isSelected,
      handleClick,
      selectable,
      inSlider,
      displayUpchargeAmount,
      showOptionPrice
    } = this.props;
    const { id, displayName } = optionValue.toObject();
    const htmlId = inSlider
      ? `option_value_${id}_slider`
      : `option_value_${id}`;

    let classSet = ["selection text-option"];
    let onClick = handleClick.bind(this, id);

    if (isSelected) {
      classSet.push("selection-selected");
    }

    if (!selectable) {
      classSet.push("unselectable");
      onClick = null;
    }

    classSet = classSet.join(" ");

    return (
      <div onClick={onClick} key={id} className={classSet} id={htmlId}>
        <div className="selection-details">
          <p>{displayName}</p>

          {showOptionPrice && (
            <p className="selection-details-price">{displayUpchargeAmount}</p>
          )}
        </div>
      </div>
    );
  }
}
